import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { AsdCallbackComponent } from './asd-callback/asd-callback.component';
import { LoginRedirectService } from './login-redirect.service';
import { SsoOptionsService } from './sso-options.service';
import { AuthGuardService } from './auth-guard.service';
import { LoggedInService } from './logged-in.service';
import { SsoOptions } from './sso-options';
import { AuthInterceptorService } from './auth-interceptor.service';

@NgModule({
  imports: [CommonModule, MatProgressBarModule],
  declarations: [AsdCallbackComponent],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true }],
})
export class SsoModule {
  static forRoot(ssoOptions: SsoOptions): ModuleWithProviders<SsoModule> {
    return {
      ngModule: SsoModule,
      providers: [
        AuthGuardService,
        LoggedInService,
        SsoOptionsService,
        LoginRedirectService,
        {
          provide: 'SsoOptions',
          useValue: ssoOptions,
        },
      ],
    };
  }
}
